import { FilterSection } from "../index";
import styles from "./shopcategories.module.css";
import { IoMdClose } from "react-icons/io";
const ShopFilters = ({
  categories,
  // colors,
  minPrice,
  maxPrice,
  brands,
  filtersProps,
  filtersActions,
}) => {
  const { mobileFiltersOpen } = filtersProps;
  const { setMobileFiltersOpen } = filtersActions;
  const closeMobileFilters = () => setMobileFiltersOpen(false);
  return (
    <>
      {/* DESKTOP SIDEBAR */}
      <aside className={styles.sidebar}>
        <div className={styles.filterCard}>
        
          <FilterSection
            minPrice={minPrice}
            maxPrice={maxPrice}
            categories={categories} 
              brands={brands}  
            // colors={colors}
            filtersProps={filtersProps}
            filtersActions={filtersActions}
          />
        </div>
      </aside>
      {/* MOBILE (UNCHANGED) */}
      {mobileFiltersOpen && (
        <div
          className={styles.mobileFiltersOverlay}
          onClick={closeMobileFilters}
        >
          <div
            className={styles.mobileFiltersPanel}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.mobileFiltersHeader}>
              <h3>Filters</h3>
              <button
                onClick={closeMobileFilters}
                className={styles.closeButton}
              >
                <IoMdClose size={20} />
              </button>
            </div>
            <FilterSection
              minPrice={minPrice}
              maxPrice={maxPrice}
              categories={categories}
              // colors={colors}  
              filtersProps={filtersProps}
              filtersActions={filtersActions}
            />
          </div>
        </div>
      )}
    </>
  );
};
export default ShopFilters;